import React from "react";
import PropTypes from "prop-types";
import { Box, Chip } from "@mui/material";

export default function EventTagList({ event }) {
  const tags = Array.isArray(event?.tags) ? event.tags : [];
  if (!tags.length) return null;

  const eventKey = event?._id || event?.id || "event";
  const seenTags = {};

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      {tags.map((tag) => {
        seenTags[tag] = (seenTags[tag] || 0) + 1;
        return (
          <Chip
            key={`${eventKey}-${tag}-${seenTags[tag]}`}
            label={tag}
            size="small"
            variant="outlined"
            sx={{ maxWidth: "100%" }}
          />
        );
      })}
    </Box>
  );
}

EventTagList.propTypes = {
  event: PropTypes.shape({
    _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tags: PropTypes.arrayOf(PropTypes.string),
  }),
};

EventTagList.defaultProps = {
  event: null,
};
